
define('template!pimSearchTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="content pim-search">\n  <div class="well">\n    <div class="search-header">\n      <h2>' +
((__t = ( _.i18n('common.productFinder', null, 'Product finder') )) == null ? '' : __t) +
'</h2>\n      ';
 if (hasResults) { ;
__p += '\n        <span class="results-count">' +
((__t = ( results.length )) == null ? '' : __t) +
'' +
((__t = ( hasMore ? '+' : '' )) == null ? '' : __t) +
' ' +
((__t = ( results.length === 1 ? 'product' : 'products' )) == null ? '' : __t) +
'</span>\n      ';
 } ;
__p += '\n    </div>\n\n    <div class="search-bar">\n      <div class="search-input-wrap">\n        <i class="fa fa-search search-icon" aria-hidden="true"></i>\n        <input type="text" class="js-search-input search-input" placeholder="' +
((__t = ( _.i18n('common.search', null, 'Search products by name, code or supplier...') )) == null ? '' : __t) +
'" />\n      </div>\n      <div class="js-supplier-region supplier-wrap"></div>\n      <button class="js-search-btn search-btn">\n        <span>' +
((__t = ( _.i18n('common.search', null, 'Search') )) == null ? '' : __t) +
'</span>\n      </button>\n    </div>\n\n    <div class="js-loader loader-3" style="display: none;"></div>\n\n    <div class="js-error alert alert-danger" style="display: none;"></div>\n\n    ';
 if (hasResults) { ;
__p += '\n      <div class="results-grid js-results">\n        ';
 _.each(results, function(item){ ;
__p += '\n          <div class="grid-item">\n            <a class="result-card js-result-card ' +
((__t = ( (typeof compareIds !== 'undefined' && _.contains(compareIds, String(item.id))) ? 'is-compared' : '' )) == null ? '' : __t) +
'" data-product-id="' +
((__t = ( item.id )) == null ? '' : __t) +
'" href="#pim/products/' +
((__t = ( item.id )) == null ? '' : __t) +
'" title="' +
((__t = ( (item.productName || '').replace(/"/g, '&quot;') )) == null ? '' : __t) +
'">\n              <div class="result-thumb">\n                <img src="' +
((__t = ( item.img )) == null ? '' : __t) +
'" alt="" loading="lazy" decoding="async" />\n                ';
 if (item.deprecated) { ;
__p += '\n                  <span class="deprecated-badge" title="' +
((__t = ( _.i18n('productList.outDated', null, 'Out of date') )) == null ? '' : __t) +
'">\n                    <i class="mdi-action-info-outline" aria-hidden="true"></i>\n                  </span>\n                ';
 } ;
__p += '\n                ';
 if (item.fastDelivery) { ;
__p += '\n                  <span class="fast-delivery-badge" title="' +
((__t = ( _.i18n('common.fastDelivery', null, 'Fast delivery') )) == null ? '' : __t) +
'">\n                    <i class="fa fa-bolt" aria-hidden="true"></i>\n                  </span>\n                ';
 } ;
__p += '\n                <span class="compare-badge" title="' +
((__t = ( _.i18n('compare.selected', null, 'Selected for compare') )) == null ? '' : __t) +
'">\n                  <i class="fa fa-check" aria-hidden="true"></i>\n                  <span>' +
((__t = ( _.i18n('compare.selectedShort', null, 'Comparing') )) == null ? '' : __t) +
'</span>\n                </span>\n              </div>\n              <div class="card-body">\n                <div class="card-title">' +
((__t = ( item.productName || item.productCode || '—' )) == null ? '' : __t) +
'</div>\n                <div class="card-codes">\n                  <span class="code-tag" title="Product code">' +
((__t = ( item.productCode )) == null ? '' : __t) +
'</span>\n                  ';
 if (item.supplierProductCode && item.supplierProductCode !== item.productCode) { ;
__p += '\n                    <span class="code-tag code-tag--muted" title="Supplier code">' +
((__t = ( item.supplierProductCode )) == null ? '' : __t) +
'</span>\n                  ';
 } ;
__p += '\n                </div>\n                ';
 if (item.supplierName) { ;
__p += '\n                  <div class="card-supplier">' +
((__t = ( item.supplierName )) == null ? '' : __t) +
'</div>\n                ';
 } ;
__p += '\n                <div class="card-badges">\n                  ';
 if (item.stockQty != null && item.stockQty > 0) { ;
__p += '\n                    <span class="badge-pill badge-pill--green">In stock</span>\n                  ';
 } ;
__p += '\n                  ';
 if (item.printAreasSummary) { ;
__p += '\n                    <span class="badge-pill badge-pill--blue" title="' +
((__t = ( item.printAreasSummary )) == null ? '' : __t) +
'">\n                      <i class="fa fa-print" aria-hidden="true"></i> Print\n                    </span>\n                  ';
 } ;
__p += '\n                  ';
 if (item.colors && item.colors.length) { ;
__p += '\n                    <span class="badge-pill badge-pill--neutral">' +
((__t = ( item.colors.length )) == null ? '' : __t) +
' colors</span>\n                  ';
 } ;
__p += '\n                </div>\n                ';
 if (item.colors && item.colors.length) { ;
__p += '\n                  <div class="color-dots">\n                    ';
 var maxDots = 8; var extra = Math.max(0, item.colors.length - maxDots); ;
__p += '\n                    ';
 for (var i = 0; i < Math.min(item.colors.length, maxDots); i++) { var c = item.colors[i]; ;
__p += '\n                      ';
 if (c.value) { ;
__p += '\n                        <span class="dot" title="' +
((__t = ( c.label || '' )) == null ? '' : __t) +
'">\n                          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">\n                            <circle cx="7" cy="7" r="6" fill="' +
((__t = ( c.value )) == null ? '' : __t) +
'" stroke="rgba(0,0,0,0.1)" stroke-width="1" />\n                          </svg>\n                        </span>\n                      ';
 } else { ;
__p += '\n                        <span class="dot is-empty" title="' +
((__t = ( c.label || '' )) == null ? '' : __t) +
'"></span>\n                      ';
 } ;
__p += '\n                    ';
 } ;
__p += '\n                    ';
 if (extra > 0) { ;
__p += '\n                      <span class="dot more">+' +
((__t = ( extra )) == null ? '' : __t) +
'</span>\n                    ';
 } ;
__p += '\n                  </div>\n                ';
 } ;
__p += '\n                ';
 if (item.nbrOffer != null || item.nbrOrder != null) { ;
__p += '\n                  <div class="card-stats">\n                    ';
 if (item.nbrOffer != null) { ;
__p += '\n                      <span class="stat-item" title="Offers"><span class="stat-val">' +
((__t = ( item.nbrOffer )) == null ? '' : __t) +
'</span> offers</span>\n                    ';
 } ;
__p += '\n                    ';
 if (item.nbrOrder != null) { ;
__p += '\n                      <span class="stat-item" title="Orders"><span class="stat-val">' +
((__t = ( item.nbrOrder )) == null ? '' : __t) +
'</span> orders</span>\n                    ';
 } ;
__p += '\n                    ';
 if (item.conversionRate != null) { ;
__p += '\n                      <span class="stat-item" title="Conversion rate"><span class="stat-val">' +
((__t = ( (Math.round(item.conversionRate * 10) / 10) )) == null ? '' : __t) +
'%</span> conv</span>\n                    ';
 } ;
__p += '\n                  </div>\n                ';
 } ;
__p += '\n              </div>\n              <div class="card-actions js-card-actions">\n                <button class="action-btn action-btn--secondary js-info-btn" title="Show details" aria-label="Show info about this product">\n                  <i class="fa fa-info-circle" aria-hidden="true"></i>\n                  <span>Info</span>\n                </button>\n                <button class="action-btn action-btn--secondary js-compare-btn ' +
((__t = ( (typeof compareIds !== 'undefined' && _.contains(compareIds, String(item.id))) ? 'is-active' : '' )) == null ? '' : __t) +
'"\n                        data-product-id="' +
((__t = ( item.id )) == null ? '' : __t) +
'"\n                        title="' +
((__t = ( _.i18n('compare.toggle', null, 'Add to compare') )) == null ? '' : __t) +
'"\n                        aria-label="' +
((__t = ( _.i18n('compare.toggle', null, 'Add to compare') )) == null ? '' : __t) +
'">\n                  <i class="fa fa-balance-scale" aria-hidden="true"></i>\n                  <span>' +
((__t = ( _.i18n('compare.toggle', null, 'Compare') )) == null ? '' : __t) +
'</span>\n                </button>\n                <span class="action-btn action-btn--primary js-open-link">\n                  <i class="fa fa-external-link" aria-hidden="true"></i>\n                  <span>Open</span>\n                </span>\n              </div>\n            </a>\n          </div>\n        ';
 }); ;
__p += '\n        ';
 if (loadingMore) { ;
__p += '\n          <div class="grid-item loader-item" aria-hidden="true">\n            <div class="loader-3" title="Loading more"></div>\n          </div>\n        ';
 } ;
__p += '\n      </div>\n    ';
 } else if (!loading) { ;
__p += '\n      <div class="js-empty empty-state">\n        <div class="empty-icon">\n          <i class="fa fa-search" aria-hidden="true"></i>\n        </div>\n        <div class="empty-title">' +
((__t = ( term ? 'No products found' : 'Search the product catalog' )) == null ? '' : __t) +
'</div>\n        <div class="empty-text">' +
((__t = ( term ? 'Try adjusting your search terms' : 'Enter a product name, code or supplier to get started' )) == null ? '' : __t) +
'</div>\n      </div>\n    ';
 } ;
__p += '\n  </div>\n\n  <!-- Floating compare tray ----------------------------------- -->\n  <div class="js-compare-tray pim-compare-tray" style="display: none;">\n    <div class="pim-compare-tray-thumbs js-compare-tray-thumbs"></div>\n    <div class="pim-compare-tray-actions">\n      <span class="pim-compare-tray-count js-compare-tray-count">0</span>\n      <span class="pim-compare-tray-cap">/ ' +
((__t = ( (typeof compareMax !== 'undefined' ? compareMax : 4) )) == null ? '' : __t) +
'</span>\n      <button class="btn btn-default btn-sm js-compare-clear">\n        ' +
((__t = ( _.i18n('common.clear', null, 'Clear') )) == null ? '' : __t) +
'\n      </button>\n      <button class="btn btn-primary btn-sm js-compare-open" disabled>\n        <i class="fa fa-balance-scale"></i>\n        ' +
((__t = ( _.i18n('compare.openView', null, 'Compare') )) == null ? '' : __t) +
'\n      </button>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

